import { ComponentProps, useEffect, useRef } from 'react';

import WebViewer, { WebViewerInstance } from '@pdftron/webviewer';

interface PdfViewerProps extends ComponentProps<'div'> {
  url: string;
}

const PdfViewer = (props: PdfViewerProps) => {
  const { url, ...args } = props;
  const viewerDiv = useRef<HTMLDivElement>(null);
  const instance = useRef<WebViewerInstance | null>(null);

  useEffect(() => {
    WebViewer(
      {
        path: '/webviewer/lib',
        disabledElements: ['header', 'toolsHeader'],
        initialDoc: url,
      },
      viewerDiv.current as HTMLDivElement,
    ).then((inst) => {
      instance.current = inst;
      inst.UI.disableTools(['header', 'AnnotationCreateFreeText']);
    });
  }, []);

  useEffect(() => {
    if (instance.current) {
      instance.current.UI.loadDocument(url);
    }
  }, [url]);

  return <div ref={viewerDiv} {...args} />;
};

export default PdfViewer;
